import { Directive, inject, OnInit } from '@angular/core';
import { LoadingController, ToastController } from '@ionic/angular';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { getMobile } from './service/base.service';
import { MessageService } from 'primeng/api';
import { Device } from '@awesome-cordova-plugins/device/ngx';


type NotificationMessage = {
    title: string;
    message: string;
}

@Directive()
export class BaseComponent implements OnInit{
    label = environment.label;
    loading: any = null;
    fullScreenLoading: any = null;
    protected constructor(
        public router: Router,
        public toastController: ToastController,
        public loadingController: LoadingController,
        public messageService?: MessageService,
        public device?: Device
    ) {
    }

    ngOnInit(): void {

    }

    public async message(text: string) {
        const toast = await this.toastController.create({
          message: text,
          duration: 10000
        });
        toast.present();
    }

    public async openLoading(mensagem: string) {
        if(this.loading == null){
            this.loading = this.loadingController.create({
                message: mensagem,
                spinner: 'circles',
                cssClass: 'custom-loading'
            });
        }

        (await this.loading).present();
    }

    public async openFullLoading(mensagem: string) {
        if(this.fullScreenLoading == null){
            this.fullScreenLoading = this.loadingController.create({
                message: mensagem,
                spinner: 'circles',
                cssClass: 'custom-full-screen-loading',
            });
            (await this.fullScreenLoading).present();
        }

    }

    public async closeFullLoading() {
        if(this.fullScreenLoading != null){
            (await this.fullScreenLoading).dismiss().then(() =>{
                this.fullScreenLoading = null;
            });
        }
    }

    public async closeLoading() {
        if(this.loading != null){
            (await this.loading).dismiss().then(() =>{
                this.loading = null;
            });
        }
    }

    public formatData(date: string){
        return new Date(date);
    }

    public isMobile(){
        return getMobile();
    }

    public showSuccessMessage({ title, message }: NotificationMessage) {
        this.messageService.add({ key: 'toast', severity: 'success', summary: title, detail: message, icon: 'pi-file' });
    }

    public showErrorMessage({ title, message }: NotificationMessage) {
        this.messageService.add({ severity: 'error', summary: title, detail: message });
    }

    public showInfoMessage(title: string, message: string) {
        this.messageService.add({ severity: 'info', summary: title, detail: message });
    }


    public formatarValorEmReais(valor: number) {
      return `R$ ${valor.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`;
    }

    public formatarValorEmX(valor: number) {
      return `X$ ${valor.toLocaleString('pt-BR', {
        currency: 'BRL',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`;
    }

    public isWeb(){
        return this.device?.platform === 'browser';
    }

    public isMobileNative(){
        return this.device?.platform === 'android' || this.device?.platform === 'ios';
    }
 }
